import { useState, useEffect } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import api from '../../utils/api';
import { format } from 'date-fns';

export default function AdminParents() {
  const [parents, setParents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get('/admin/parents').then(r => setParents(r.data.parents || [])).finally(() => setLoading(false));
  }, []);

  const filtered = parents.filter(p =>
    p.full_name?.toLowerCase().includes(search.toLowerCase()) ||
    p.email?.toLowerCase().includes(search.toLowerCase())
  );

  const adjustWallet = async (parentId, currency) => {
    const type = window.confirm('Add credit? Click OK for credit, Cancel for debit.') ? 'credit' : 'debit';
    const amount = window.prompt('Amount (e.g. 8.00):');
    if (!amount) return;
    const reason = window.prompt('Reason:');
    if (!reason) return;
    await api.post('/admin/parents/' + parentId + '/wallet', { amount: parseFloat(amount), currency, type, reason });
    window.location.reload();
  };

  const sym = (p) => p.currency === 'USD' ? '$' : 'GBP ';
  const balance = (p) => p.currency === 'USD' ? p.wallet_balance_usd : p.wallet_balance_gbp;

  return (
    <DashboardLayout title="Parents" subtitle="All registered parents">
      <div style={{marginBottom:20,display:'flex',gap:12,alignItems:'center'}}>
        <input type="text" className="form-input" placeholder="Search by name or email..."
          value={search} onChange={e=>setSearch(e.target.value)} style={{maxWidth:360}}/>
        <span style={{fontSize:'0.82rem',color:'var(--ink-400)',fontWeight:600}}>{filtered.length} parents</span>
      </div>

      {loading ? <div className="loading-screen"><div className="spinner"/></div>
        : filtered.length === 0
        ? <div style={{textAlign:'center',padding:40,color:'var(--ink-400)'}}><p>No parents found.</p></div>
        : <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {filtered.map(p => (
            <div key={p.id} className="card" style={{padding:18}}>
              <div style={{display:'flex',gap:14,alignItems:'flex-start',flexWrap:'wrap'}}>
                <div className="avatar-placeholder avatar-md" style={{fontSize:'0.9rem',flexShrink:0}}>
                  {p.full_name?.split(' ').map(w=>w[0]).join('')}
                </div>
                <div style={{flex:1,minWidth:200}}>
                  <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap',marginBottom:4}}>
                    <strong style={{fontSize:'1rem'}}>{p.full_name}</strong>
                    <span className={'badge ' + (p.is_active?'badge-green':'badge-red')}>
                      {p.is_active?'Active':'Suspended'}
                    </span>
                  </div>
                  <div style={{fontSize:'0.8rem',color:'var(--ink-400)',marginBottom:8}}>
                    {p.email} · {p.country} · Joined {format(new Date(p.created_at),'d MMM yyyy')}
                  </div>
                  <div style={{display:'flex',gap:20,flexWrap:'wrap'}}>
                    <div style={{textAlign:'center'}}>
                      <div style={{fontSize:'1.2rem',fontWeight:800,color:'var(--green-700)'}}>
                        {sym(p)}{parseFloat(balance(p)||0).toFixed(2)}
                      </div>
                      <div style={{fontSize:'0.72rem',color:'var(--ink-400)'}}>Wallet balance</div>
                    </div>
                    <div style={{textAlign:'center'}}>
                      <div style={{fontSize:'1.2rem',fontWeight:800}}>{p.total_bookings || 0}</div>
                      <div style={{fontSize:'0.72rem',color:'var(--ink-400)'}}>Total bookings</div>
                    </div>
                    <div style={{textAlign:'center'}}>
                      <div style={{fontSize:'1.2rem',fontWeight:800}}>{p.active_bookings || 0}</div>
                      <div style={{fontSize:'0.72rem',color:'var(--ink-400)'}}>Active bookings</div>
                    </div>
                    <div style={{textAlign:'center'}}>
                      <div style={{fontSize:'1.2rem',fontWeight:800,color:'var(--ink-400)'}}>
                        {sym(p)}{parseFloat(p.total_spent||0).toFixed(2)}
                      </div>
                      <div style={{fontSize:'0.72rem',color:'var(--ink-400)'}}>Total spent</div>
                    </div>
                  </div>
                </div>
                <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                  <button className="btn btn-secondary btn-sm"
                    onClick={()=>adjustWallet(p.id, p.currency)}>
                    Adjust wallet
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      }
    </DashboardLayout>
  );
}
